import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSetVehicleTypesDataAction } from "../../../actions/dataActions";
import { getDataFresh, getVehicleTypesData } from "../../../state/selectors";
import Spinner from "react-spinner-material";
import { Box, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import { useVehicleTypeData } from "../../../hooks/useVehicleTypeData";
import NewVehicleType from "./NewVehicleType";
import VehicleTypeRow from "./VehicleTypeRow";
import PaginationWrapper from "../../Utils/PaginationWrapper";

function VehicleTypeView(props) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const dataFresh = useSelector(getDataFresh);

  const complete = useVehicleTypeData({ page }, dataFresh);

  const onVehicleTypeUpdate = (index, newVehicleType) => {
    let newResults = [...data.results]
    let newState = {...data, results: newResults};
    newState.results[index] = newVehicleType;
    dispatch(createSetVehicleTypesDataAction(newState));
  };

  const data = useSelector(getVehicleTypesData);

  if (!complete) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          spinnerColor={"#3273dc"}
          spinnerWidth={2}
        />
      </Box>
    );
  }

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <NewVehicleType />
      <Box>
          <details>
              <summary><Title>Vehicle Types</Title></summary>
            <Title size="6">
              Note: Modifying these values will update the vehicle types of existing
              vehicles!
            </Title>
            <Table>
              <thead>
              <tr>
                <th>Vehicle Type</th>
                <th>Special Labour Rate</th>
                <th>Fixed Hire Costs</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              {data.results.map((value, index) => (
                  <VehicleTypeRow
                    key={value.id}
                    vehicleTypeData={value}
                    index={index}
                    endpoint={props.endpoint}
                    onVehicleTypeUpdate={onVehicleTypeUpdate}
                  />
                ))}
              </tbody>
            </Table>
            <PaginationWrapper
              setPage={setPage}
              page={page}
              dataCount={Math.ceil(data.count / 25)}
            />
          </details>
      </Box>
    </div>
  );
}

export default VehicleTypeView;
